import type { GraphqlUserInputError } from '~/app/api/graphql/errors';
import { ClientError } from 'graphql-request';
import type { FormError } from 'use-form-state';

/** Parses GraphQL client error and returns an array of `FormError`s */
export function processGraphqlFormErrors(error: unknown): FormError[] {
    // TODO: this function shouldn't be responsible for logging.
    // This should be a middleware on the client itself or on the query hooks
    if (process.env.NODE_ENV === 'development') {
        console.error('GraphQL Error:', error);
    }

    if (!(error instanceof ClientError)) return [];
    if (!error.response.errors?.length) return [];

    console.error('processGraphqlFormErrors:', error);

    const errors = new Array<FormError>();

    for (const e of error.response.errors) {
        if (e.extensions.code !== 'USER_INPUT_ERROR' satisfies typeof GraphqlUserInputError.CODE) continue; // prettier-ignore

        errors.push(...parseNestedErrors(e.extensions.fields));
    }

    return errors;
}

function parseNestedErrors(fields: any, path = ''): FormError[] {
    return Object.entries(fields ?? {}).flatMap(([key, value]: [string, any]) => {
        const newPath = path ? `${path}.${key}` : key;

        // Handle direct string values (from UserInputError)
        if (typeof value === 'string') {
            return { path: newPath, message: value };
        }

        // Handle Zod format with _errors array
        if (value._errors && value._errors.length > 0) {
            return { path: newPath, message: value._errors[0] };
        }

        // Recurse for nested objects
        if (typeof value === 'object' && value !== null) {
            return parseNestedErrors(value, newPath);
        }

        return [];
    });
}
